module.exports = function(app) {
	'use strict';
	app.directive('findEmployeeResults', [function() {
		return {
			restrict: 'A',
			replace: false,
			templateUrl: 'manage-employees/find.employerTemplate.html/directives/employee/findEmployeeResults',

			controller: ['$scope', 'employeeFinder', function($scope, employeeFinder) {
				$scope.employeeFinder = employeeFinder;
			}]
		};
	}]);
};
